import { useEnhancedNavigate, useStableValue } from '../../../common/hooks'
import type { Tag } from '../../../common/types/common'
import { compressAndEncodeJSON } from '../../../common/utils/jsonCompression'
import TimeLayout from '../TimeLayout'
import ApplicationCategoriesStats from './ApplicationCategoriesStats'
import TimeStats from './TimeStats'

const Time = () => {
  const { enhancedNavigate: navigate } = useEnhancedNavigate()

  // Stabilize objects to prevent unnecessary re-renders
  const stableAppQueryOptions = useStableValue({ tagsOfInterestSource: 'application' as const })

  return (
    <div className='flex h-3/4 flex-col gap-3'>
      <TimeStats />
      <ApplicationCategoriesStats />
      <TimeLayout
        queryOptionsApplications={stableAppQueryOptions}
        queryOptionsActivities={stableAppQueryOptions}
        onNavigate={(tags: Tag[]) => navigate(compressAndEncodeJSON(tags))}
        hasColorAppCategories
      />
    </div>
  )
}

export default Time

